<script setup lang="ts">
  defineOptions({ name: 'EmCardBody' })
</script>

<template>
  <div class="emerald-card__body">
    <slot />
  </div>
</template>
